import { Info } from "lucide-react";

/**
 * Displays a plain-English "what affects the cost" list plus a disclaimer.
 * Never publishes invented prices.
 */
export default function CostFactors({
  title = "What affects the cost",
  intro = "The cost of this service depends on the specifics of your premises and system. Following a site survey we provide a clear quotation.",
  factors = [],
}) {
  return (
    <section className="fss-section bg-slate-50 border-y border-slate-200" data-testid="cost-factors">
      <div className="fss-container grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <div className="fss-overline">Cost information</div>
          <h2 className="mt-3 font-display text-3xl md:text-4xl font-semibold text-slate-900 leading-tight">
            {title}
          </h2>
          <p className="mt-4 text-slate-600 leading-relaxed">{intro}</p>
          <div className="mt-6 flex items-start gap-3 p-4 border border-slate-200 bg-white rounded-sm">
            <Info className="w-5 h-5 text-slate-500 shrink-0 mt-0.5" />
            <p className="text-xs text-slate-600 leading-relaxed">
              We do not publish generic prices online — every premises is
              different. Please contact us for a tailored quotation based on
              your specific requirements.
            </p>
          </div>
        </div>
        <div className="lg:col-span-7">
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {factors.map((f, i) => (
              <li
                key={i}
                className="flex items-start gap-3 p-4 bg-white border border-slate-200 text-sm text-slate-700 rounded-sm"
                data-testid={`cost-factor-${i}`}
              >
                <span className="w-6 h-6 flex items-center justify-center rounded-sm bg-green-700 text-white text-xs font-bold shrink-0">
                  {i + 1}
                </span>
                <span>{f}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
